import { render, staticRenderFns } from "./commonCar.vue?vue&type=template&id=af413528&scoped=true&"
import script from "./commonCar.vue?vue&type=script&lang=js&"
export * from "./commonCar.vue?vue&type=script&lang=js&"
import style0 from "./commonCar.vue?vue&type=style&index=0&id=af413528&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af413528",
  null
  
)

export default component.exports